var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A6FF",
    d: "M50 25.49c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.947 29.834a15.6 15.6 0 0 1-.661-4.498C9.286 16.711 16.32 9.72 25 9.72c8.678 0 15.714 6.992 15.714 15.617 0 3.519-1.17 6.764-3.145 9.375A15.72 15.72 0 0 1 25 40.954"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.427 27.723a25 25 0 0 1-.112-2.387C15.315 16.711 19.65 9.72 25 9.72s9.685 6.992 9.685 15.617c0 3.13-.57 6.046-1.554 8.49M25 33.359V9.719M9.563 22.405l30.874.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M34.275 12.728A11.62 11.62 0 0 1 25 17.318a11.62 11.62 0 0 1-9.274-4.59M25 40.955c-5.626-.202-9.022-4.1-9.022-4.1l-3.97 4.1V30.072h11.155l-3.183 2.837c7.677 8.772 18.172.977 18.172.977"
  }))));
};
export default SvgCross;